import { render } from "./kitOrderPrintModel.vue?vue&type=template&id=450f7726"
import script from "./kitOrderPrintModel.vue?vue&type=script&lang=js"
export * from "./kitOrderPrintModel.vue?vue&type=script&lang=js"

import "./kitOrderPrintModel.vue?vue&type=style&index=0&id=450f7726&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__